module.exports = __webpack_public_path__ + "img/01-thumb.5fba85c8.png";